import {
  getItemSessionStorage,
  removeItemSessionStorage,
  setFreshSessionStorage,
} from './session';
import {
  EditEmailProps,
  EditPhoneProps,
  LoginProfileInfoProps,
  SetupProfileInfoProps,
  ediSchema,
  loginProfileSchema,
  setupProfileSchema,
} from './types';

export const setEditEmail = (value: EditEmailProps) => {
  setFreshSessionStorage('edit_email', value);
};

export const getEditEmail = (): EditEmailProps | null => {
  const item = getItemSessionStorage('edit_email');

  return item ? ediSchema.parse(JSON.parse(item)) : null;
};

export const removeEditEmail = () => {
  removeItemSessionStorage('edit_email');
};

export const setEditPhone = (value: EditPhoneProps) => {
  setFreshSessionStorage('edit_phone', value);
};

export const getEditPhone = (): EditPhoneProps | null => {
  const item = getItemSessionStorage('edit_phone');

  return item ? ediSchema.parse(JSON.parse(item)) : null;
};

export const removeEditPhone = () => {
  removeItemSessionStorage('edit_phone');
};

export const setupProfileInfo = (value: SetupProfileInfoProps) => {
  setFreshSessionStorage('setup_profile', value);
};

export const getProfileInfo = (): SetupProfileInfoProps | null => {
  const item = getItemSessionStorage('setup_profile');

  return item ? setupProfileSchema.parse(JSON.parse(item)) : null;
};

export const removeProfileInfo = () => {
  removeItemSessionStorage('setup_profile');
};

export const setLoginProfileInfo = (value: LoginProfileInfoProps) => {
  setFreshSessionStorage('login_profile', value);
};

export const getLoginProfileInfo = (): LoginProfileInfoProps | null => {
  const item = getItemSessionStorage('login_profile');

  return item ? loginProfileSchema.parse(JSON.parse(item)) : null;
};

export const removeLoginProfileInfo = () => {
  removeItemSessionStorage('login_profile');
};
